import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, CLUB_LOGO } from "@/lib/api";
import { ArrowLeft, Calendar as CalIcon } from "lucide-react";

export default function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/news/${id}`).then((r) => setN(r.data)).catch((e) => setErr(e.response?.data?.detail || "Erreur"));
  }, [id]);

  if (err) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-16 text-center">
        <p className="text-[#DC2626] font-semibold">{err}</p>
        <Link to="/actualites" className="mt-4 inline-flex items-center gap-2 text-[#1E3A8A] font-semibold hover:text-[#D97706] transition-colors">
          <ArrowLeft size={14} /> Retour aux actualités
        </Link>
      </div>
    );
  }

  if (!n) return <div className="max-w-3xl mx-auto px-4 py-16 text-[#475569]">Chargement...</div>;

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14" data-testid="news-detail">
      <Link to="/actualites" className="inline-flex items-center gap-2 text-sm text-[#1E3A8A] font-semibold hover:text-[#D97706] transition-colors" data-testid="back-to-news">
        <ArrowLeft size={14} /> Toutes les actualités
      </Link>

      <div className="mt-6 text-[10px] tracking-[0.2em] uppercase text-[#D97706] font-bold flex items-center gap-2">
        <CalIcon size={12} /> {new Date(n.published_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
        <span className="text-[#475569] ml-2 normal-case tracking-normal font-normal">· par {n.author}</span>
      </div>
      <h1 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0F172A] tracking-tighter leading-[1.1]" style={{ fontFamily: "Outfit" }}>
        {n.title}
      </h1>

      {n.image_url ? (
        <img src={n.image_url} alt={n.title} className="mt-8 w-full aspect-[16/9] object-cover rounded-lg" />
      ) : (
        <div className="mt-8 w-full aspect-[16/9] bg-gradient-to-br from-[#1E3A8A] to-[#0F172A] rounded-lg flex items-center justify-center">
          <img src={CLUB_LOGO} alt="VU" className="h-32 w-32 object-contain opacity-80" />
        </div>
      )}

      <div className="prose prose-slate max-w-none mt-8 text-[#0F172A] whitespace-pre-wrap text-base lg:text-lg leading-relaxed">
        {n.content}
      </div>
    </article>
  );
}
